import React from 'react';
import styled, { css } from 'styled-components';

type Option<T> = {
  label: string;
  value: T;
};

type ColorCodedOptionLabel = {
  label: string;
  bgColor: string;
};

const SelectOptionWrapper = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    align-items: center;
    gap: ${spacing['4']};
  `}
`;

const CircleStatusIndicator = styled.div<{ $bgColor: string }>`
  ${({ theme: { borderRadius }, $bgColor }) => {
    return css`
      width: 16px;
      height: 16px;
      border-radius: ${borderRadius.full};
      display: inline-block;
      background-color: ${$bgColor};
    `;
  }}
`;

export const ColorCodedOption = ({ bgColor, label }: ColorCodedOptionLabel) => {
  return (
    <SelectOptionWrapper>
      <CircleStatusIndicator $bgColor={bgColor} />
      <div>{label}</div>
    </SelectOptionWrapper>
  );
};

export const createColorCodedOptions =
  <T,>(options: (Option<T> & ColorCodedOptionLabel)[]) =>
  ({ label, value }: Option<T>) => {
    return (
      <ColorCodedOption
        label={label}
        bgColor={options.find((x) => x.value === value)?.bgColor ?? '#fff'}
      />
    );
  };
